import { useMemo, useState, useEffect } from 'react';
import { Stack, Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';
// banner Images
import banner1 from '../../assets/login/male_doctor_examaining.jpeg';
import banner2 from '../../assets/login/therapist_with_patient.jpeg';
import banner3 from '../../assets/login/doctor_with_stethoscope.jpeg';

const BannerSection = () => {
    const banners = useMemo(() => [
        {
            img: banner1,
            title: "Easily Find Your Specialty Medications",
            subtitle: "OptioRx's Pharmacies Provide The Finest Care And Medications To Meet The Unique Needs Of Each Patient."
        },
        {
            img: banner2,
            title: "OptioRx’s Belief and Commitment",
            subtitle: "OptioRx is dedicated and focused on providing the highest level of care and support to patients and their families."
        },
        {
            img: banner3,
            title: "OptioRx’s Mission",
            subtitle: "Our Mission is to create and provide the highest quality of customized compounded medications in a broad range of therapies for patients nationwide."
        }
    ], [])
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(true);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const nextSlide = () => {
        setFade(false);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
            setFade(true);
        }, 300);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const bannerStyles = {
        position: 'relative',
        height: { xs: '300px', md: '100vh' },
        display: { xs: isMobile ? 'none' : 'block', md: 'block' },
        p: 2
    };

    const overlayStyles = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '96.6%',
        height: '97%',
        m: 2,
        borderRadius: { xs: '20px', md: '30px' },
        background: 'linear-gradient(179deg, rgba(102, 160, 183, 0.00) -5.79%, rgba(104, 139, 170, 0.25) 28.1%, rgba(108, 88, 137, 0.85) 68.96%, #6D4B81 98.73%)',
    };

    return (
        <Grid
            item
            xs={false}
            md={6}
            sx={bannerStyles}
        >
            <Box
                component="img"
                src={banners[currentIndex].img}
                alt="Login visual"
                sx={{
                    width: '100%',
                    height: '100%',
                    borderRadius: { xs: '20px', md: '30px' },
                    objectFit: 'cover',
                    transition: "opacity 0.5s ease-in-out",
                    opacity: fade ? 1 : 0,

                }}
            />
            <Box sx={overlayStyles} />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: { xs: '20px', md: '55px' },
                    left: { xs: '20px', md: '55px' },
                    right: { xs: '20px', md: '40px' },
                    color: 'white',
                    zIndex: 2,
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        fontSize: { xs: '24px', sm: '28px', md: '32px', lg: '42px' },
                        fontWeight: 500,
                        mb: 3,
                        width: '80%',
                    }}
                >
                    {banners[currentIndex].title}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' },
                        mb: 4,
                        width: '80%',
                    }}
                >
                    {banners[currentIndex].subtitle}
                </Typography>
                <Stack direction="row" spacing={1}>
                    {banners.map((_, index) => (
                        <Box
                            key={index}
                            sx={{
                                width: index === currentIndex ? 36 : 16,
                                height: 8,
                                bgcolor: index === currentIndex ? "#E39121" : "#ccc",
                                borderRadius: "15px",
                            }}
                        />
                    ))}
                </Stack>
            </Box>
        </Grid>
    )

}

export default BannerSection;